import { render } from "./Points.vue?vue&type=template&id=96f0005c&scoped=true"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"

import "./Points.vue?vue&type=style&index=0&id=96f0005c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f0005c"]])

export default __exports__